import _ from 'lodash';
import UtilCache from '@dap/shared-utils/cache';
import CommService from '@dap/shared-api/common/commonService';
// 设备信息
import UAChecker from '../utils/uaChecker';
// 上报请求
import Metrics from '../metrics';
// 处理后的路由信息
import { autoGetName, setMonitorConfigMap, getHasStatus, getCurrentPageState } from '../autoGetName';

const UA = new UAChecker();
class MonitorSDK {
    constructor (debug = false) {
        this.os = UA.getOS() ?? 'unknown os';
        this.osVersion = UA.getOSVersion() ?? 'unknown os version';
        this.browser = UA.getBrowser() ?? 'unknown browser';
        this.browserVersion = UA.getBrowserVersion() ?? 'unknown browser version';
        // 所有设备信息
        this.ua = UA.getAll();
        // 用户信息
        this.userInfo = null;
        // 调试
        this.debug = debug;
        this.wxReport = debug;
        // 每隔10秒上报一次
        this.reportTimeGap = 10 * 1000;
        // 60分
        this.maxTime = 60 * 10 * 1000;
        // this.reportTimeGap = 2 * 1000;
        // this.maxTime = 10 * 1000;
        // this.modules = {};
        // 当前页信息
        this.current = {};
        // 计时器
        this.timerInterval = null;
        // 定时器-关闭自动上报
        this.overTimeTimeout = null;
        // 控制关闭自动上报
        this.reachMaxTimes = false;
        // 页面是否可见
        this.isVisible = true;
        // 监控列表
        this.monitorList = [];
    }

    // 初始化
    init () {
        // 赋值用户信息
        this.initDict();

        // 监听页签关闭 - 调用上报方法
        window.removeEventListener('beforeunload', () => this.leavePage(this.current));
        window.addEventListener('beforeunload', () => this.leavePage(this.current));

        // 监听页签切换 - 调用自动上报/定时关闭自动上报
        document.removeEventListener('visibilitychange', () => this.switchTab());
        document.addEventListener('visibilitychange', () => this.switchTab());

        // 监听键盘鼠标操作事件, 用于重置监听器
        this.autoOperateDetect();

        // 清除本地缓存
        // UtilCache.setCacheWithChain('monitorList', []);
    }

    // 赋值用户信息
    initDict () {
        this.userInfo = this.getUserInfo();
    }

    // 获取用户信息
    getUserInfo () {
        const userInfo = UtilCache.getLocalItem('userInfo') || {};

        return {
            id: userInfo?.id,
            username: userInfo?.name,
            group: userInfo?.group,
        };
    }

    // 判断是否开启了高级配置 - 开启了每次获取最新的数据
    getItemStatus (path) {
        const currentItem = getCurrentPageState(path, true);
        return currentItem && getHasStatus(currentItem);
    }

    // 获取页面信息
    getParams (page, wxMsg = '当前页面上报中') {
        if (!this.userInfo) this.initDict();
        // 重新获取页面信息
        let itemStatus = this.getItemStatus(page.path);
        let itemName = '';
        if (itemStatus) {
            // 为了保持定时上报 市场为最新的
            let newPageInfo = autoGetName(page.path);
            itemName = newPageInfo.name;
        } else {
            itemName = page.name || '';
        }

        const reportParams = {
            os: this.os,
            user: this.userInfo.username,
            group: this.userInfo.group,
            modules: itemName,
            path: page.path,
            host: page.host,
        };

        // const wxParams = {
        //     ...reportParams,
        //     httpProtocol: window.location.protocol,
        //     osVersion: this.osVersion,
        //     browser: this.browser,
        //     browserVersion: this.browserVersion,
        //     ua: this.ua,
        //     currentTime: new Date().toLocaleString(),
        // };
        // if (this.wxReport || page.name === undefined) {
        //     wxRobot(wxParams, wxMsg);
        // }

        return reportParams;
    }

    // 监听页签关闭事件
    leavePage (page) {
        // 判断页面是否在
        if (!this.getPageStatus(page.path)) {
            return;
        }

        // modules为空则不上报
        const params = this.getParams(page, '离开页面');
        if (!params.modules) {
            return;
        }

        // 清除计时器/定时器
        clearInterval(this.timerInterval);
        clearTimeout(this.overTimeTimeout);

        // 调用上报方法
        Metrics.recordPageDuration(10, params);
    }

    // 监听页签切换事件
    switchTab () {
        // 页面是否可见
        this.isVisible = document.visibilityState === 'visible';
        if (this.isVisible) {
            // 自动上报
            this.autoReport();
            // 计时关闭自动上报
            this.manualEvent();
        } else {
            this.leavePage(this.current);
        }
    }

    // 自动上报
    autoReport () {
        // 判断页面是否在
        if (!this.getPageStatus(this.current.path)) {
            return;
        }

        const params = this.getParams(this.current, '停留页面10秒了');
        // modules为空则不上报
        if (!params.modules) {
            return;
        }

        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        this.timerInterval = setInterval(() => {
            if (this.isVisible && !this.reachMaxTimes) {
                // 调用上报方法
                Metrics.recordPageDuration(10, params);
            }
        }, this.reportTimeGap);
    }

    // 计时关闭自动上报
    manualEvent () {
        // 判断页面是否在
        if (!this.getPageStatus(this.current.path)) {
            return;
        }

        clearTimeout(this.overTimeTimeout);
        this.reachMaxTimes = false;
        this.overTimeTimeout = setTimeout(() => {
            // 关闭自动上报
            this.reachMaxTimes = true;
        }, this.maxTime);
    }

    // 键盘鼠标操作事件, 用于重置监听器
    autoOperateDetect () {
        // 重置计时关闭自动上报功能
        const debounceManualEvent = _.throttle(this.manualEvent, 1000).bind(this);
        // 单击
        window.removeEventListener('click', debounceManualEvent);
        window.addEventListener('click', debounceManualEvent);
        // 双击
        window.removeEventListener('dblclick', debounceManualEvent);
        window.addEventListener('dblclick', debounceManualEvent);
        // 移入
        window.removeEventListener('mouseup', debounceManualEvent);
        window.addEventListener('mouseup', debounceManualEvent);
        // 移出
        window.removeEventListener('mousedown', debounceManualEvent);
        window.addEventListener('mousedown', debounceManualEvent);
        // 移动
        window.removeEventListener('mousemove', debounceManualEvent);
        window.addEventListener('mousemove', debounceManualEvent);
        // 键盘
        window.removeEventListener('keydown', debounceManualEvent);
        window.addEventListener('keydown', debounceManualEvent);
        // 键盘松开
        window.removeEventListener('keyup', debounceManualEvent);
        window.addEventListener('keyup', debounceManualEvent);
        // 键盘按下
        window.removeEventListener('keypress', debounceManualEvent);
        window.addEventListener('keypress', debounceManualEvent);
    }

    // 路由跳转
    async handleChangeRouter (from, to) {
        if (!UtilCache.getLocalItem('token')) {
            return;
        }
        // 获取监控列表
        await this.getMonitorList();
        // 设置监控配置
        setMonitorConfigMap();

        // 离开页面是否上报
        if (this.getPageStatus(from.path)) {
            const oldPage = autoGetName(from.path) ?? {};
            this.leavePage(oldPage);
        }

        // 新打开页面路由信息
        this.current = autoGetName(to.path) ?? {};
        // 是否在监控配置列表中
        this.getPageStatus(to.path) && this.enterPage();

        // console.log('from 状态: ', this.getPageStatus(from.path), 'to 状态: ', this.getPageStatus(to.path));
    }

    // APIs
    enterPage () {
        // 判断页面是否在
        if (!this.getPageStatus(this.current.path)) {
            return;
        }

        const params = this.getParams(this.current, '进入页面');
        // modules为空则不上报
        if (!params.modules) {
            return;
        }

        this.isVisible = true;
        // 开始自动上报
        this.autoReport();
        // 设置定时器, 10分钟后不上报
        this.manualEvent();

        Metrics.recordPageRequest(params);
    }

    // 获取监控列表
    getMonitorList () {
        return new Promise((resolve, reject) => {
            this.monitorList = UtilCache.getCacheWithChain('monitorList');
            // 缓存数据
            if (this.monitorList && this.monitorList.length) {
                resolve(this.monitorList);
            } else {
                // 获取监控列表
                CommService.getMonitorList().then((res) => {
                    this.monitorList = res.data.data.rows ?? [];
                    // 设置本地缓存
                    UtilCache.setCacheWithChain('monitorList', this.monitorList);
                    resolve(this.monitorList);
                });
            }
        });
    }

    // 判断页面配置
    getPageStatus (url) {
        // Warning YO 微前端地址
        // console.log('getCurrentPageState(url)', url, getCurrentPageState(url))
        const isProd = window.location.hostname === 'dap.lilithgame.com' || window.location.hostname === 'dap-staging.micro-stage.lilith.sh'
        || window.location.hostname === 'dap-staging-2.micro-stage.lilith.sh';
        return isProd && getCurrentPageState(url);
    }
}

const Monitor = new MonitorSDK();
export default Monitor;
